import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M3 7V5a2 2 0 0 1 2-2h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17 3h2a2 2 0 0 1 2 2v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 17v2a2 2 0 0 1-2 2h-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 21H5a2 2 0 0 1-2-2v-2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Scan";
const Scan = memo(themed(Icon));
export {
  Scan
};
//# sourceMappingURL=scan.js.map
